// eslint-disable-next-line no-restricted-imports
import ImageBase, { ImageProps as ImagePropsBase } from 'next/image';

export type ImageProps = ImagePropsBase;

export default function Image({ src, ...rest }: ImageProps) {
  return <ImageBase {...rest} src={src ?? ''} />;
}
